import React from 'react';
import PropTypes from 'prop-types';
import { Row } from '../../structure/row';
import { Cell, LEFT, RIGHT } from '../../structure/cell';
import { FormattedPrice } from '../../../price/formatted_price';

export function Cashback100(props) {
    if (typeof props.discount !== 'undefined' && props.discount > 0) {
        return (
            <Row className="sidebar__row--discount discount discount--cashback-100">
                <Cell side={LEFT}>
                    <div className="discount__tag">Discount</div>
                    <div className="discount__name">Cashback</div>
                </Cell>
                <Cell side={RIGHT}>
                    <FormattedPrice
                        price={props.discount}
                        currencyIsoCode={props.currencyIsoCode}
                        className="discount__price"
                        inCents={false}
                    />
                </Cell>
            </Row>
        );
    }

    return null;
}

Cashback100.propTypes = {
    discount: PropTypes.number.isRequired,
    currencyIsoCode: PropTypes.string.isRequired,
};
